<template>
    <div class="report-query">
        <img v-show="!searched" class="search-img" :src="require('@/assets/query-service/report-empty.svg')" alt="" />

        <div class="search-input">
            <a-input-search placeholder="请输入报告编号" size="large" @search="getList">
                <a-button slot="enterButton">查询</a-button>
            </a-input-search>
        </div>

        <empty-result v-if="empty && searched" />

        <result-card v-if="!empty && searched" title="报告信息" :labelMap="labelMapper" :result="formValue">
            <a-button slot="tail" @click="searched = false">返回</a-button>
        </result-card>
    </div>
</template>

<script>
import { getReportList } from '../../common/api';
import emptyResult from './components/empty-result.vue';
import ResultCard from './components/result-card.vue';

export default {
    components: {
        emptyResult,
        ResultCard
    },
    data() {
        return {
            empty: false,
            searched: false,
            labelMapper: {
                reportNo: '报告编号',
                contractcode: '合同编号',
                allMtlName: '样品名称',
                companyname: '委托单位',
                fileTime: '签发日期',
                statusCode: '状态'
            },
            statusMapper: {
                draft_undo: '报告撤回',
                draft: '报告编制',
                approve: '报告初审',
                charge: '技术负责人审核',
                audit: '报告审核',
                authorize: '报告批准',
                undo: '报告撤回',
                done: '已完成'
            },
            formValue: {
                reportNo: '',
                contractcode: '',
                allMtlName: '',
                companyname: '',
                fileTime: '',
                statusCode: ''
            }
        };
    },
    methods: {
        async getList(value) {
            const { data } = await getReportList({ f: { reportNo_SEQ: value }, n: -1 });
            this.searched = true;

            if (!data.length) {
                this.empty = true;
                return;
            }
            for (const key in this.formValue) {
                const val = data[0][key];
                if (key === 'companyname' || key === 'contractcode') {
                    this.formValue[key] = data[0].ext$[key];
                    continue;
                }
                if (key === 'statusCode') {
                    this.formValue[key] = this.statusMapper[val];
                    continue;
                }
                if (val) {
                    this.formValue[key] = val;
                }
            }
            this.empty = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.report-query {
    display: flex;
    flex-direction: column;
    align-items: center;

    .search-img {
        width: 320px;
        height: 176px;
        margin: 48px auto 24px;
    }

    .search-input {
        width: 560px;
        height: 80px;
        padding: 0 8px;
        display: flex;
        align-items: center;

        .ant-btn-lg {
            height: 48px;
            background: #005299;
            border: 1px solid rgba(0, 82, 153, 1);
            border-radius: 0px 4px 4px 0px;
            font-size: 18px;
            color: #ffffff;
            letter-spacing: 0;
            text-align: center;
            font-weight: 600;
            padding: 0 30px;
        }
    }
}
</style>
